import type { SVGProps } from 'react'

export const ChartPlusAdd = (props: SVGProps<SVGSVGElement>) => (
  <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M14.1666 23.5664V28.5664"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.8333 15.2324V28.5658"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M27.4998 18.5664V28.5664"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.6665 8.56641H31.8515C33.5915 8.56641 34.9998 9.97474 34.9998 11.7147V32.0847C34.9998 33.8247 33.5915 35.2331 31.8515 35.2331H9.81484C8.07484 35.2331 6.6665 33.8247 6.6665 32.0847V18.5664"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.33325 8.56576H9.99992"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.66659 11.8991V5.23242"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
